<script>
    import Icon from '../components/Icon.svelte';

    import { createEventDispatcher, onMount } from 'svelte';
    import ButtonBase from 'common/ButtonBase.svelte';
    // import { IDLE, INCALL, OUTCALL, OUTGOING, RINGING } from 'common/callState';
    import { getContactName } from 'common/utils.js';

    // export let session;
    export let peer;
    // export let state;
    export let ring;

    const dispatch = createEventDispatcher();

    const hangup = () => {
        dispatch('hangup');
    };

    const answer = () => {
        dispatch('answer');
    };

    let peer_name = getContactName(peer);

    onMount(() => {
        ring.play();
    });
</script>

<div id="incoming-call" class="row content">
    <section class="display-flex">
        <div class="caller-info">
            {#if peer_name && peer_name !== peer}
                <div class="caller-name">{peer_name}</div>
            {/if}
            <div class="caller-number">{peer}</div>
        </div>

        <div class="caller-avatar incoming-call-avatar">
            <Icon icon="caller-avatar" size="55" />
        </div>

        <div class="dialer-icons">
            <ButtonBase on:click={answer}>
                <div class="bg-green">
                    <Icon icon="dialer" size="22" color="#30A059" />
                </div>
            </ButtonBase>

            <ButtonBase on:click={hangup}>
                <div class="bg-red">
                    <Icon icon="end-call" color="#EF3333" size="22" />
                </div>
            </ButtonBase>
        </div>
    </section>
</div>

<style lang="scss">
    #incoming-call {
        section {
            .caller-number {
                font-family: 'Urbanist';
                font-style: normal;
                font-weight: 500;
                font-size: 14px;
                line-height: 140%;
                color: #616c74;
            }

            .incoming-call-avatar {
                width: 100px;
                height: 100px;
                margin-bottom: 80px;
            }

            .caller-info {
                display: flex;
                align-items: center;
                justify-content: center;
                flex-direction: column;
                gap: 4px;
                margin-bottom: 24px;
                margin-top: 40px;
            }

            .dialer-icons {
                display: flex;
                align-items: center;
                justify-content: space-around;
                width: 50%;
            }

            .bg-green {
                // width: 40px;
                // height: 40px;
                background: #dff9e8;
                border-radius: 50%;
                padding: 14px;
                display: flex;
                align-items: center;
                justify-content: center;
            }

            .bg-red {
                // width: 40px;
                // height: 40px;
                background: #ffe8e8;
                border-radius: 50%;
                padding: 14px;
                display: flex;
                align-items: center;
                justify-content: center;
            }

            .caller-avatar {
                display: flex;
                align-items: center;
                justify-content: center;
                background: #673ab3;
                border-radius: 50%;
            }
        }
    }
</style>
